/* global $3Dmol */

export function ShowSurface(viewerRef, currentColor, opacity, surfaceRef) {
    const viewer = viewerRef.current;
    if (!viewer) return; 

    viewer.removeAllSurfaces(); // Clear existing surfaces

    try {
        const surface = viewer.addSurface(window.$3Dmol.SurfaceType.MS, {
            opacity: opacity || 0.5,
            color: currentColor === 'MediumBlue' ? 'SkyBlue' : (currentColor || 'SkyBlue'),
            colorscheme: 'Chain'
        });

        if (surfaceRef) {
            surfaceRef.current = surface;
        }
        
        
        viewer.render();
        
        
    } catch (error) {
        console.error('Error in ShowSurface:', error);
    }
}